import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'ProfessionalAssignmentFavorites',
  inputShow: gql`
    query professionalAssignmentFavorites($input: ProfessionalAssignmentFavoriteQueryInput) {
      professionalAssignmentFavorites(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Professional Assignment Favorites',
  },
};
